import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuardService } from './accessLevelGuard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  { 
    path: 'login',
    loadChildren: './public/public.module#PublicModule'
  },
  {
    path: 'admin',
    loadChildren: './admin/admin.module#AdminModule',
    canActivate: [RoleGuardService],
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [RoleGuardService],
  exports: [RouterModule]
})
export class AppRoutingModule { }
